import React from "react";
import Product from "./Product";

const Products = ({ products }) => {
  return (
    <section className="product-list">
      <div className="product-grid">
        {products?.map((item, index) => (
          <Product item={item} key={index} />
        ))}
      </div>
    </section>
  );
};

export default Products;
